import { IconButton } from "@mui/material";
import {
  useContext,
  type FC,
  type MouseEvent,
  type PropsWithChildren,
} from "react";
import { useTranslation } from "react-i18next";

import { SVG_MUI } from "@ryde/assets";
import { ConflictsNav, ExpandedAdornment } from "@ryde/controls";
import { greyMui } from "@ryde/theme";

import { BulkPreviewStepConflictsContext } from "../bulk-preview-step-conflicts.context";

type IRejectedBookingExpandedProps = PropsWithChildren;

export const RejectedBookingExpanded: FC<IRejectedBookingExpandedProps> = ({
  children,
}) => {
  const { t } = useTranslation();
  const { conflicts, onRefresh, isPreview, titleTranslationKeys } = useContext(
    BulkPreviewStepConflictsContext,
  );
  const errorType = conflicts?.at(0)?.errorType;
  const titleKey =
    (errorType && titleTranslationKeys?.[errorType]) ||
    `booking.bulk.${errorType}`;

  const onAdornmentClick = (event: MouseEvent): void => {
    event.stopPropagation();

    onRefresh?.();
  };

  return (
    <ExpandedAdornment
      NavControl={
        <ConflictsNav
          title={t(titleKey)}
          conflictNumber={conflicts?.length ?? 0}
        />
      }
      EndAdornment={
        isPreview ? (
          <IconButton size="small" onClick={onAdornmentClick}>
            <SVG_MUI.ArrowsRotate3SVG color={greyMui.A700} />
          </IconButton>
        ) : undefined
      }
    >
      {children}
    </ExpandedAdornment>
  );
};
